export function filterMapLocations(
  locations,
  { enabled = false, search = "", category = "All" } = {}
) {
  if (!enabled) return [];
  const term = String(search || "").trim().toLowerCase();

  return locations.filter((location) => {
    if (category !== "All" && location.serviceType !== category) return false;
    if (!term) return true;

    return [
      location.name,
      location.description,
      location.serviceType,
      location.keywords,
      location.postcode,
      location.address,
      location.website,
      location.contact,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .includes(term);
  });
}
